import { HttpStatusCode } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IdentityAuthService } from '../services/identity-auth.service';
import { JwtAuthService } from '../services/jwt-auth.service';
import { LanguageService } from 'app/shared/services/language.service';
import { SSOLogin } from 'app/models/auth/ssoLogin';

@Component({
  selector: 'app-signin-oidc',
  templateUrl: './signin-oidc.component.html',
  styleUrls: ['./signin-oidc.component.scss']
})
export class SigninOidcComponent implements OnInit {
  redirectUrl: string;
  failedLogin: boolean = false;
  statusCode: number;
  statusCode400: number = HttpStatusCode.BadRequest
  statusCode500: number = HttpStatusCode.InternalServerError

  constructor(
    private identityService: IdentityAuthService,
    private jwtService: JwtAuthService,
    private translateService: TranslateService
  ) {
    this.redirectUrl = identityService.postLogin();
  }

  ngOnInit(): void {
    this.setDefaultLanguage();
    
    this.jwtService.failedLogin$.subscribe(res => {
      let ssoLogin = res as SSOLogin;

      this.identityService.isAuthenticated = false;
      this.failedLogin = ssoLogin.failedLogin;
      this.statusCode = ssoLogin.statusCode;
    });
  }

  public setDefaultLanguage() {
    let language = localStorage.getItem(LanguageService.LANG_CACHE_KEY);
    if (!!!language) {
      language = LanguageService.LANG_SR_CYRL_RS;
      localStorage.setItem(LanguageService.LANG_CACHE_KEY, LanguageService.LANG_SR_CYRL_RS);
    }
    
    this.translateService.setDefaultLang(language);
    this.translateService.use(language);
  }

  backToLoginPage(): void {
    this.identityService.logOut(); // radi se logout na eID.gov.rs nakon cega se radi redirekcija na pocetnu stranu za login
  }

}
